module.exports = __webpack_public_path__ + "img/pc4.84dbd310.png";